export default "__VITE_ASSET__50ae8c40__"